import About from "./components/About";
import Navbar from "./components/Navbar";
import Textform from "./components/Textform";
import React,{ useState } from 'react'
import Alert from "./components/Alert";

function App() {
  const[mode, setMode] = useState('light') // wheather dark mode is enabled or not
  const [alert, setalert] = useState(null)

  // alert function

  const showalert = (message ,type)=>{
    setalert({
      msg:message,
      type:type
    })
    setTimeout(() => {
      setalert(null)
    }, 1500);
  }

  const togglemode=()=>{
    if(mode==='light'){
      setMode('dark');
      document.body.style.backgroundColor = 'grey';
      showalert("Dark mode has been enabled" , "success")
    }
    else if(mode==='dark'){
      setMode('light');
      document.body.style.backgroundColor = 'white';
      showalert("Light mode has been enabled" , "success")
    }
  }
  return (
    <>
<Navbar title = "TextUtils" Abouttext=" Abouttext" mode={mode} togglemode={togglemode}/>
<Alert alert = {alert}/>
<Textform showalert = {showalert} heading="Enter Your Text to Analyze"/>
{/* <About/>  */}
</>
  );
}

export default App;
